module.exports = __webpack_public_path__ + "img/device_1015_1.25ad345d.svg";